import React from 'react';
import { Card, CardBody } from 'reactstrap';

function formatTokens(value) {
  if (value === 'unlimited' || value == null) {
    return 'Unlimited';
  }
  return Number(value).toLocaleString();
}

function WorkspaceAiUsage({ usage }) {
  if (!usage) {
    return null;
  }

  if (!usage.allow_ai_analysis) {
    return (
      <Card className="mt-3">
        <CardBody>
          <h5>AI analysis</h5>
          <p className="mb-0 text-muted">
            Included org analysis is not on this plan. You can still download an
            org results pack from an organization assessment.
          </p>
        </CardBody>
      </Card>
    );
  }

  return (
    <Card className="mt-3">
      <CardBody>
        <h5>AI analysis</h5>
        <p className="mb-1">
          {formatTokens(usage.remaining)} of {formatTokens(usage.unit_limit)}{' '}
          included analysis units remaining this month.
        </p>
        <p className="mb-0 text-muted">
          Used {formatTokens(usage.units_used)} units in the current period.
          Costlier models spend units faster than the digest model.
        </p>
      </CardBody>
    </Card>
  );
}

export default WorkspaceAiUsage;
